import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatSliderModule } from '@angular/material/slider';
import { MatCheckboxModule } from '@angular/material/checkbox';
import Keycloak from 'keycloak-js';
import { MatDialog } from '@angular/material/dialog';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTabsModule } from '@angular/material/tabs';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { DropdownPopupComponent } from '../components/dropdown-popup/dropdown-popup.component';
import { WarningDialogueComponent } from '../components/warning-dialogue/warning-dialogue.component';
import { ConfigService } from '../services/config.service';
import { KeycloakService } from 'keycloak-angular';
import { GlobalService } from '../../../../../my-shared-lib/src/lib/shared-services/global.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss',
  providers: [],
  imports: [
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatTableModule,
    MatSliderModule,
    MatCheckboxModule,
    ScrollingModule,
    MatTooltipModule,
    MatTabsModule,
    MatStepperModule,
  ],
})
export class SurveyComponent implements OnInit {
  // --- Survey close logic ---
  surveyClosed = false;
  //  const closeDate = new Date('2026-09-14T23:59:59Z');
  // ngOnInit() {
  //   const now = new Date();
  //   // Survey closes after August 7, 2025 (US time)
  //   // US is behind IST, so close after 7th Aug UTC+0 (midnight 8th Aug IST)
  //   // For simplicity, close after 2025-08-07T23:59:59 UTC

  //   if (now > closeDate) {
  //     this.surveyClosed = true;
  //   }
  //   // ...existing code...
  // }
  // surveyClosed = false;
  market = [];
  selectedMarket = ['All'];
  step = 1;
  scoreFields: string[] = [
    'TCO',
    'affordability',
    'availability',
    'sustainability',
    'productivity',
  ];

  displayedColumns: string[] = [
    'product',
    'keycompetitor',
    ...this.scoreFields,
    'notes',
  ];

  data: any;
  userInfo: any;
  def: any;
  selectedTabIndex = 0;
  marketSegment: string[] = [];
  marketData: any = {};
  commonNotes: string = '';
  selectedSurveyType = '';
  surveyDeadlineLabel = 'the configured deadline';
  surveyAvailabilityChecked = false;
  noOpenSurveys = false;
  @ViewChild('stepper')
  stepper!: MatStepper;
  engine: any;
  constructor(
    private service: ConfigService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private keycloakService: KeycloakService,
    private globalService: GlobalService
  ) {}

  async ngOnInit(): Promise<void> {
    const isLoggedIn = await this.keycloakService.isLoggedIn();
    if (isLoggedIn) {
      const userDetails = await this.keycloakService.loadUserProfile();
      this.userInfo = userDetails;
    }

    this.selectedSurveyType = localStorage.getItem('selectedSurveyType') || '';
    this.loadSurveyDeadline();

    this.globalService.getMarketSeg().subscribe((res: any) => {
      this.market =
        res?.responseList?.[0]?.responseData?.[0].segments;
    });
    this.service.getDef().subscribe((def) => {
      this.def = def;
    });
  }

  private loadSurveyDeadline(): void {
    this.service.getDashboardConfig('settings/list-of-survey.json').subscribe({
      next: (config: any) => {
        const tableConfig = this.findSurveyListTableConfig(config);
        const readAction = this.resolveSurveyReadAction(tableConfig);
        if (!readAction?.payload) {
          this.markNoOpenSurveys();
          return;
        }

        const payload = this.replacePayloadTokens(readAction.payload);
        this.service
          .customApi(
            readAction.url || tableConfig?.apiUrl || '/spriced/platform',
            payload,
            readAction.method || 'post'
          )
          .subscribe({
            next: (response: any) => {
              const rows = this.extractSurveyRows(response, tableConfig);
              const publishedRows = this.getPublishedSurveyRows(rows);
              if (!publishedRows.length) {
                this.markNoOpenSurveys();
                return;
              }

              this.noOpenSurveys = false;
              this.surveyAvailabilityChecked = true;
              const survey = this.resolveCurrentSurvey(publishedRows);
              const endDate = this.parseScheduleDate(survey?.end_date);
              if (!endDate) {
                this.surveyDeadlineLabel = 'the configured deadline';
                return;
              }

              this.surveyDeadlineLabel = this.formatDeadlineDate(endDate);
              const today = this.toDateOnly(new Date()).getTime();
              this.surveyClosed = endDate.getTime() < today;
            },
            error: (error) => {
              console.error('Failed to load survey deadline', error);
              this.markNoOpenSurveys();
            },
          });
      },
      error: (error) => {
        console.error('Failed to load survey configuration', error);
        this.markNoOpenSurveys();
      },
    });
  }

  private markNoOpenSurveys(): void {
    this.noOpenSurveys = true;
    this.surveyClosed = false;
    this.surveyAvailabilityChecked = true;
    this.step = 1;
    this.surveyDeadlineLabel = 'the configured deadline';
  }

  private findSurveyListTableConfig(config: any): any {
    const pageContent = Array.isArray(config?.pageContent)
      ? config.pageContent
      : [];

    for (const row of pageContent) {
      const columns = Array.isArray(row?.columns) ? row.columns : [];
      const tableConfig = columns.find(
        (column: any) => column?.widgetId === 'surveyListTable'
      );
      if (tableConfig) {
        return tableConfig;
      }
    }

    return null;
  }

  private resolveSurveyReadAction(tableConfig: any): any {
    if (tableConfig?.initialLoadAction?.payload) {
      return tableConfig.initialLoadAction;
    }

    const actionIndex = Number(tableConfig?.initialLoadPostSaveActionIndex);
    if (
      Number.isInteger(actionIndex) &&
      Array.isArray(tableConfig?.postSaveActions)
    ) {
      return tableConfig.postSaveActions[actionIndex];
    }

    return Array.isArray(tableConfig?.postSaveActions)
      ? tableConfig.postSaveActions[0]
      : null;
  }

  private replacePayloadTokens(value: any): any {
    if (Array.isArray(value)) {
      return value.map((item) => this.replacePayloadTokens(item));
    }

    if (value && typeof value === 'object') {
      return Object.entries(value).reduce(
        (acc: Record<string, any>, [key, item]) => {
          acc[key] = this.replacePayloadTokens(item);
          return acc;
        },
        {}
      );
    }

    if (typeof value !== 'string') {
      return value;
    }

    const currentYear = new Date().getFullYear();
    if (value === '__YEAR__' || value === '__CURRENT_YEAR__') {
      return currentYear;
    }

    return value.replace(/__YEAR__|__CURRENT_YEAR__/g, String(currentYear));
  }

  private extractSurveyRows(response: any, tableConfig: any): any[] {
    const responseData = response?.responseList?.[0]?.responseData;
    const primaryPayload = Array.isArray(responseData)
      ? responseData[0]
      : responseData;
    const respKey = tableConfig?.respKey;
    const candidates = respKey
      ? [
          primaryPayload?.[respKey],
          response?.responseList?.[0]?.[respKey],
          response?.[respKey],
          responseData,
          response?.responseData,
        ]
      : [responseData, response?.responseData, primaryPayload, response];

    return candidates.find((candidate) => Array.isArray(candidate)) || [];
  }

  private getPublishedSurveyRows(rows: any[]): any[] {
    const today = this.toDateOnly(new Date()).getTime();
    return rows.filter((row: any) => {
      const status = String(row?.status || '').trim().toLowerCase();
      const isPublished = status === 'published';
      const startDate = this.parseScheduleDate(row?.start_date);
      const endDate = this.parseScheduleDate(row?.end_date);
      return (
        isPublished &&
        (!startDate || startDate.getTime() <= today) &&
        (!endDate || endDate.getTime() >= today)
      );
    });
  }

  private resolveCurrentSurvey(openRows: any[]): any {
    const selectedType = this.selectedSurveyType.trim().toLowerCase();
    if (selectedType) {
      const selectedOpenSurvey = openRows.find(
        (row: any) =>
          String(row?.survey_type || '').trim().toLowerCase() === selectedType
      );
      if (selectedOpenSurvey) {
        return selectedOpenSurvey;
      }

    }

    return openRows[0] || null;
  }

  private parseScheduleDate(value: any): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return this.toDateOnly(value);
    }

    if (typeof value === 'string') {
      const datePart = value.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (datePart) {
        const year = Number(datePart[1]);
        const month = Number(datePart[2]);
        const day = Number(datePart[3]);
        if ([year, month, day].every(Number.isFinite)) {
          return new Date(year, month - 1, day);
        }
      }
    }

    const parsed = new Date(value);
    return Number.isNaN(parsed.getTime()) ? null : this.toDateOnly(parsed);
  }

  private toDateOnly(value: Date): Date {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  private formatDeadlineDate(value: Date): string {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ];

    return `${value.getDate()}-${months[value.getMonth()]}-${value.getFullYear()}`;
  }

  async start() {
    if (!this.surveyAvailabilityChecked || this.noOpenSurveys || this.surveyClosed) {
      return;
    }

    this.getEngine();
    const dialogRef = this.dialog.open(DropdownPopupComponent, {
      width: '400px',
      data: { market: this.market },
    });
    const confirmed = await dialogRef.afterClosed().toPromise();
    if (!confirmed) return;
    this.selectedMarket = confirmed;
    this.step = 2;
    let market: string[] = [];
    if (this.selectedMarket.includes('All')) {
      market = [];
      this.marketSegment = this.market;
    } else {
      market = this.selectedMarket;
      this.marketSegment = this.selectedMarket;
    }
    this.service
      .getSurveyProducts(this.marketSegment, this.engine)
      .subscribe((productIds: any) => {
        productIds = productIds?.responseList?.[0]?.responseData?.[0];
        const allProducts: any[] = [];

        ['q1', 'q2', 'q3', 'q4'].forEach((quarter) => {
          if (productIds[quarter]) {
            allProducts.push(...productIds[quarter]);
          }
        });
        this.data = allProducts.map((product: any) => {
          const row: any = {
            product: product.name,
            keycompetitor: product.keyCompetitor || '',
            TCO: 0,
            affordability: 0,
            availability: 0,
            productivity: 0,
            sustainability: 0,
            notes: '',
            isNA: {},
            edited: false,
          };
          this.scoreFields.forEach((field) => {
            row.isNA[field] = false;
          });

          return row;
        });
        this.marketSegment.forEach((segment) => {
          this.marketData[segment] = this.data
            .filter((row: any) => {
              const words = row.product?.trim().split(/\s+/); // handles multiple spaces
              const lastWord = words?.[words.length - 1];
              return lastWord.toLowerCase() === segment.toLowerCase();
            })
            .sort((a: any, b: any) => {
              const numA = parseFloat(a.product?.match(/\d+/)?.[0] || '0');
              const numB = parseFloat(b.product?.match(/\d+/)?.[0] || '0');
              return numA - numB;
            });
        });
      });
  }
  getEngine() {
    this.globalService
      .getEngineModel(this.marketSegment)
      .subscribe((engineModel: any) => {
        this.engine =
          engineModel.responseList?.[0]?.responseData?.[0].engineModels;
      });
  }
  getSliderAllClasses(row: any, field: string): string {
    const dynamicClass = this.getSliderClass(row[field]); // low/med/high
    const enabledClass = row.isNA[field] ? 'slider-disabled' : 'slider-enabled';
    return `${dynamicClass} ${enabledClass}`;
  }

  getSliderClass(value: number): string {
    if (value < 4) return 'slider-low';
    if (value < 8) return 'slider-medium';
    return 'slider-high';
  }

  onSliderChanged(row: any, field: string, value: number): void {
    row[field] = value;
    if (value > 0) {
      row.isNA[field] = false;
    }
    // Track edit
    if (!row.editedFields) row.editedFields = {};
    row.editedFields[field] = true;
  }

  onCheckboxClicked(row: any, field: string): void {
    if (!row.isNA[field]) {
      row.isNA[field] = true;
      row[field] = 0;
    } else {
      row.isNA[field] = false;
      row[field] = 0; // or default slider value
    }

    // Track edit
    if (!row.editedFields) row.editedFields = {};
    row.editedFields[field] = true;
  }

  async save(type: string) {
    const username =
      `${this.userInfo?.firstName} ${this.userInfo?.lastName}`.trim() || 'User';
    const email = this.userInfo?.email;

    const incompleteIds: string[] = [];
    const surveyPayload: any[] = [];
    this.data.forEach((row: any) => {
      const isEdited =
        row.editedFields && Object.keys(row.editedFields).length > 0;
      const isProductValid = row.product?.trim();

      if (!isEdited || !isProductValid) return;

      const editedFields = Object.keys(row.editedFields);

      // Check if ALL edited fields are 0 → skip the row entirely
      const allEditedFieldsZero = editedFields.every(
        (field) =>
          !row.isNA?.[field] &&
          (row[field] === 0 ||
            row[field] === '' ||
            row[field] === null ||
            row[field] === undefined)
      );

      if (allEditedFieldsZero) {
        // Treat as not edited meaningfully, so skip it
        return;
      }

      // Check if ALL fields are > 0 or N/A → complete
      const isComplete = this.scoreFields.every((field) => {
        return row.isNA?.[field] || row[field] > 0;
      });

      if (isComplete) {
        // Valid complete row → save it
        const surveyRow: any = {
          product_id: row.product,
          email,
          userName: username,
          created_date: new Date().toISOString(),
          updated_date: new Date().toISOString(),
          notes: row.notes,
          common_notes: this.commonNotes,
        };

        this.scoreFields.forEach((field) => {
          surveyRow[field] = row.isNA?.[field] ? 'N/A' : row[field];
        });

        surveyPayload.push(surveyRow);
      } else {
        // Some fields > 0 or N/A, and some invalid → mark incomplete
        incompleteIds.push(row.product);
      }
    });
    if (incompleteIds.length > 0) {
      const dialogRef = this.dialog.open(WarningDialogueComponent, {
        width: '400px',
        data: { productIds: incompleteIds },
      });

      const confirmed = await dialogRef.afterClosed().toPromise();
      if (!confirmed) return;
    }
    if (surveyPayload.length === 0) {
      this.snackBar.open('No Changes to be Saved!', 'Close', {
        duration: 5000,
        horizontalPosition: 'right',
        verticalPosition: 'top',
        panelClass: ['snackbar-success'],
      });
      this.stepper.next();
      return;
    }
    this.service.saveApi(surveyPayload).subscribe({
      next: () => {
        this.snackBar.open('Survey saved successfully!', 'Close', {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['snackbar-success'],
        });
        this.stepper.next();
        if (type == 'submit') {
          this.step = 3;
        }
      },
      error: () => {
        this.snackBar.open('Failed to save survey.', 'Close', {
          duration: 5000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: ['snackbar-success'],
        });
      },
    });
  }

  back() {
    this.stepper.previous();
  }
  capitalize(field: string): string {
    return field.charAt(0).toUpperCase() + field.slice(1);
  }

  reset() {
    this.start();
  }
  getToolTip(name: string) {
    if (this.def) return this.def[name] || 'No definition available';
  }
}
